import { Pipe, PipeTransform } from "@angular/core";

/**
 * Sorts the import fields by applying priorities to specific ones
 */
@Pipe({
  name: "sortImportFields"
})
export class SortImportFieldsPipe implements PipeTransform {

  /**
   * Prioritized comparison - see //http://prochal.com/2019/06/how-to-sort-an-array-of-objects-by-a-property-value-with-priority-in-javascript/
   * @param key Key
   * @param order Order - asc or desc
   */
  private compare(key, order = 'asc') {
    const sortingOrder = {
      'ReferenceBoId': 1,
      'TargetPropertyId': 2,
      'PropertyName': 3,
      'City': 4,
      'Street': 5,
      'StreetNo': 6,
      'CurrencyCode': 7,
      'CurrencyCodeOverride': 8,
      'UnitOfLengthOverride': 9,
      'Year': 10
    };

    return (a, b) => {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }

      const first = (a[key] in sortingOrder) ? sortingOrder[a[key]] : Number.MAX_SAFE_INTEGER;
      const second = (b[key] in sortingOrder) ? sortingOrder[b[key]] : Number.MAX_SAFE_INTEGER;

      let result = 0;
      if (first < second) {
        result = -1;
      }
      else if (first > second) {
        result = 1;
      }
      return (order === 'desc') ? ~result : result
    };
  }

  /**
   * Sorts the import fields by applying priorities to specific ones
   * @param array Array of fields
   */
  transform(array: any): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    return array.sort(this.compare('key'));
  }
}
